import './Footer.scss';
import { getStandConfig } from "../../../shared/Stand";
import {FaPhoneIcon} from "../../../models/Icons.model";

const Footer = () => {
  const standConfig = getStandConfig();

  return (
    <footer className={`footer-bg ${standConfig.footerClassName}`}>
      <div className="container">
        <div className="row align-items-center">
          {/* Мобильная версия */}
          <div className="col-4 d-md-none">
            <div className="d-flex justify-content-start">
              <img
                src={standConfig.logoSrc}
                alt="BigClock Logo"
                className="footer-logo"
              />
            </div>
          </div>

          <div className="col-4 d-md-none">
            <div className="text-center">
              <h6 className="m-0 footer-title">
                Центр управления часами
              </h6>
            </div>
          </div>

          <div className="col-4 d-md-none">
            <div className="d-flex justify-content-end">
              <a
                href="tel:+74950508888"
                className="footer-phone-icon"
                title="Позвонить +7 (495) 050-88-88"
              >
                <FaPhoneIcon className="phone-icon" />
              </a>
            </div>
          </div>

          {/* Десктопная версия */}
          <div className="col-12 col-md-4 col-lg-4 d-none d-md-block">
            <div className="d-flex justify-content-center justify-content-md-start">
              <img
                src={standConfig.logoSrc}
                alt="BigClock Logo"
                className="footer-logo"
              />
            </div>
          </div>

          <div className="col-12 col-md-4 col-lg-4 d-none d-md-block">
            <div className="text-center">
              <h5 className="m-0 footer-title">
                Центр управления часами
              </h5>
            </div>
          </div>

          <div className="col-12 col-md-4 col-lg-4 d-none d-md-block">
            <div className="d-flex justify-content-center justify-content-md-end">
              <a
                href="tel:+74950508888"
                className="footer-phone-link"
              >
                +7 (495) 050-88-88
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
